import { useGetAccounts } from '@api/lendingAPI/lapiHooks';
import {
    Step,
    StepIndicator,
    StepLabel
} from '../../../myAccount/ui/components/ProgressBar/StepIndicator';

export const FundingProgressIndicator = ({ step }: { step: number }) => {
    const { data, isLoading, isError } = useGetAccounts();

    if (isLoading || isError) return null;

    const { accounts } = data;

    if (accounts.length === 0) return null;

    const isTopup =
        accounts.filter(
            (account) => account.loan_status && account.loan_status !== 'ended'
        ).length !== 0;

    return (
        <StepIndicator className="mb-3xl min-l:hidden">
            <Step number={1} isActive={step === 1} isComplete={step > 1}>
                <StepLabel>
                    {isTopup ? 'Select amount' : 'Select offer'}
                </StepLabel>
            </Step>
            <Step number={2} isActive={step === 2} isComplete={step > 2}>
                <StepLabel>Complete requirements</StepLabel>
            </Step>
            <Step number={3} isActive={step === 3}>
                <StepLabel>Confirm funds</StepLabel>
            </Step>
        </StepIndicator>
    );
};
